import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BaseUrlService {

  constructor(private router: Router) { }

  BaseUrl() {
     return "https://portal.avisoconnex.com.au"
  }
  RedirectUrl() {
    return "https://avisoconnex.com.au"
  }
}
